var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{staticClass:"mt--7",attrs:{"fluid":""}},[_c('manage-password',{attrs:{"title":"User Profile"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }